import { render, staticRenderFns } from "./blackListAdd.vue?vue&type=template&id=626ea7c6&scoped=true&"
import script from "./blackListAdd.vue?vue&type=script&lang=js&"
export * from "./blackListAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626ea7c6",
  null
  
)

export default component.exports